export function formatMapToJSONString(map: Map<string, string>): string {
  return JSON.stringify(Object.fromEntries(map));
}
